export const environment = {
  production: true,
  measurementId: 'G-4VVY23YXMF',
  apiDomain: 'nagish.io',
  recaptchaSiteKey: '6Le9ZY4sAAAAAKj8wgshA2oGW-f1fzJr9NO9X5yQ',
};
